import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, normalizeClass as _normalizeClass, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-b-1 border-b border-black-300 pb-4 pt-14 tablet:pb-8 tablet:pt-20" }
const _hoisted_2 = { class: "title max-w-[80%] font-medium leading-7" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["cursor-pointer", $data.isOpen ? 'accordion-open' : 'accordion-close']),
      onClick: [
        _cache[0] || (_cache[0] = _withModifiers($event => ($data.isOpen = !$data.isOpen), ["stop"])),
        _cache[1] || (_cache[1] = $event => ($options.pushEvent($props.title, $data.isOpen)))
      ]
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex-between", _ctx.$attrs.class])
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString($props.title), 1),
          _withDirectives(_createVNode(_component_v_icon, {
            icon: "arrow-down",
            color: $props.color,
            width: $props.iconWidth,
            height: $props.iconHeight,
            class: _normalizeClass(["transition-transform duration-200 ease-in-out", $data.isOpen && 'rotate-180'])
          }, null, 8, ["color", "width", "height", "class"]), [
            [_vShow, $options.showArrow]
          ])
        ], 2)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["grid transition-grid-template-rows duration-500", $data.isOpen ? 'grid-rows-1' : 'grid-rows-0'])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}